import React, { useEffect, useState } from 'react'
import _ from "lodash"

// @ts-ignore
import { topNavigationClick } from '@root/tracking/signals'
import iconArrowRight from "@images/iconArrowRight.png"
import I18n from 'i18n-js'
import { disableBodyScroll, enableBodyScroll } from '@root/misc/disableBodyScroll'
import Icon from './Icon'
import { authCallbacks } from '@root/misc/authCallbacks'

interface NaviProps {
  items: {url: string, name: string, active?: boolean, target?: string}[]
  profileInfo: ProfileInfo
  prizesUrl: string
}

interface ProfileInfo {
  nickname: string
  firstname: string
  lastname: string
  profileSettingsPath: string
  loggedIn: boolean
}

type NaviPropsWithBurgerControl = NaviProps & { burgerOpen: boolean, setBurgerOpen(val: boolean): void }

const UserCircle: React.FC<{ profileInfo: ProfileInfo }> = ({profileInfo}) => {
  return (
    <a
      href={profileInfo.profileSettingsPath}
      target="_blank"
      className="navi__userCircle"
      title={profileInfo.nickname}
    >
      {(profileInfo.firstname && profileInfo.lastname)
        ? <span>{profileInfo.firstname[0] ?? ""}{profileInfo.lastname[0] ?? ""}</span>
        : <span>{profileInfo.nickname[0] ?? ""}{profileInfo.nickname[1] ?? ""}</span>
      }
    </a>
  )
}

const MobileMenu: React.FC<NaviPropsWithBurgerControl> = ({items, burgerOpen, setBurgerOpen, prizesUrl}) => {
  const handleLogin = (e: MouseEvent) => {
    e.preventDefault()
    authCallbacks.login()
  }

  return <div className="navi__mobileMenu">
    <div className="navi__mobileMenu__topArea">
      <div>
        <div className="navi__mobileMenu__burgerIconHolder">
          <BurgerIcon isOpen={burgerOpen} onClick={(() => setBurgerOpen(burgerOpen ? false : true))} />
        </div>
      </div>
    </div>
    <div className="navi__mobileMenu__contentArea">
      <div className="navi__mobileMenu__contentArea__inner">
        <div className="navi__mobileMenu__navLinks">
          {_.map(items, (item, index) => {
            return <NaviLink key={index} item={item} />
          })}
        </div>
        <div className="navi__mobileMenu__prizeHolder">
          <Prize num={1} prizesUrl={prizesUrl} />
        </div>
        <div className="navi__mobileMenu__bottomLinks">
        </div>
      </div>
    </div>
  </div>
}

const Prize: React.FC<{num: number, prizesUrl: string}> = ({num, prizesUrl}) => {
  return <div className={`navi__prize navi__prize--${num}`}>
    <div className="navi__prize__box">
      <p className="navi__prize__section">{I18n.t("navigation.teaser_prizes.title")}</p>
      <h3>{I18n.t(`event_prizes.prize${num}.title`)}</h3>
      <p className="navi__prize__info">{I18n.t(`event_prizes.prize${num}.info`)}</p>
      <p><a className="neo__linkWithIcon" href={prizesUrl}>
        {I18n.t("navigation.teaser_prizes.more_link")}
        <Icon src={iconArrowRight} />
      </a></p>
    </div>
  </div>
}

const NaviBar: React.FC<NaviPropsWithBurgerControl> = ({ items }) => {
  return <>
    <TopBar
      left={<>
        {_.map(items, (item, index) => {
          return <NaviLink key={index} item={item} />
        })}
      </>}
    />
  </>
}

const BurgerIcon: React.FC<{isOpen: boolean, onClick(): void}> = ({isOpen, onClick}) => {
  const className = [
    "navi__burger",
    isOpen ? "navi__burger--open" : "navi__burger--closed",
  ].join(" ")

  return <a
    className={className}
    onClick={onClick} />
}

const TopBar: React.FC<{left?: React.ReactNode, right?: React.ReactNode}> = ({left, right}) => {
  return <div className="navi__topBar">
    <div className="navi__topBar__left">{left}</div>
    <div className="navi__topBar__right">{right}</div>
  </div>
}

const NaviLink: React.FC<{item: NaviProps["items"][number], smallerText?: boolean}> = ({item, smallerText}) => {
  const className = [
    "navi__navLink",
    item.active ? "navi__navLink--active" : "",
    smallerText ? "navi__navLink--smaller" : "",
  ].join(" ")

  const additionalProps = {
    ...topNavigationClick.trackingProps({ name: item.name }),
    ...(item.target ? { target: item.target } : {})
  }
  return <a className={className} href={item.url} {...additionalProps}>
    <span>{item.name}</span>
  </a>
}

const Navi: React.FC<NaviProps> = (props) => {
  const [burgerOpen, setBurgerOpen] = useState(false)

  useEffect(() => {
    if (burgerOpen) {
      disableBodyScroll();
    } else {
      enableBodyScroll();
    }
  }, [burgerOpen])

  useEffect(() => {
    return () => { // make sure bodyscroll enabled after unmount!
      enableBodyScroll();
    }
  }, [])

  return <div className="navigation__container">
    <NaviBar {...props} burgerOpen={burgerOpen} setBurgerOpen={setBurgerOpen} />
  </div>
}

export default Navi
